import {Space, Table, Tag, Pagination} from "antd";
import {handleRequest, apiError} from "~/utils";
import {useContext, useState} from "react";
import {AppContext} from "~/context/AppProvider";
import {Button, Icon} from "~/components";
import {purchaseOrderApi} from "~/api";
import "../../style/PurchaseOrderTable.scss";
import PurchaseOrderDetail from "./PurchaseOrderDetail";

function PurchaseOrderTable({items = [], pagination, onPaginationChange, onEdit, onDelete}) {

    const {tableHeight, appData} = useContext(AppContext);

    const [expandedKeys, setExpandedKeys] = useState([]);

    const [detailsLoading, setDetailsLoading] = useState({});

    const [detailsData, setDetailsData] = useState({});

    const handleExpandDetails = async (record) => {
        const recordId = record.id;
        const isExpanded = expandedKeys.includes(recordId);

        if (isExpanded) {
            setExpandedKeys([]);
            return;
        }

        if (!detailsData[recordId]) {
            setDetailsLoading(prev => ({...prev, [recordId]: true}));
            let [error, response] = await handleRequest(purchaseOrderApi.get(recordId));
            setDetailsLoading(prev => ({...prev, [recordId]: false}));

            if (!apiError('Lấy chi tiết phiếu nhập hàng thất bại', error, response)) {
                setDetailsData(prev => ({
                    ...prev,
                    [recordId]: response?.data?.details || []
                }));
            }
        }

        setExpandedKeys([recordId]);
    };

    const columns = [
        {
            title: 'Mã phiếu nhập',
            dataIndex: 'code',
            key: 'code',
            width: '150px',
            render: (_, record) => (
                <div onClick={() => handleExpandDetails(record)} style={{cursor: 'pointer'}}>
                    <b>{record.code}</b>
                </div>
            )
        },
        {
            title: 'Thời gian',
            dataIndex: 'created',
            key: 'created',
            width: '180px',
            render: (text, record) => (
                <div onClick={() => handleExpandDetails(record)} style={{cursor: 'pointer'}}>
                    {text}
                </div>
            ),
        },
        {
            title: 'Nhà cung cấp',
            dataIndex: 'supplier_name',
            key: 'supplier_name',
            width: '200px',
            render: (text, record) => (
                <div onClick={() => handleExpandDetails(record)} style={{cursor: 'pointer'}}>
                    {text}
                </div>
            ),
        },
        {
            title: 'Trạng thái',
            dataIndex: 'status',
            key: 'status',
            width: '120px',
            render: (status, record) => {
                const label = appData['purchaseStatus'][status] || { badge: 'default', label: status};
                return (
                    <div onClick={() => handleExpandDetails(record)} style={{cursor: 'pointer'}}>
                        <Tag color={label.badge}>{label.label}</Tag>
                    </div>
                );
            }
        },
        {
            title: 'Hành động',
            key: 'action',
            width: '120px',
            render: (_, record) => (
                (record?.status === 'draft' || record?.status === 'cancel') &&
                <div onClick={(event) => event.stopPropagation()}>
                    <Space>
                        {
                            (record?.status === 'draft') && <Button
                                background
                                blue
                                small
                                onClick={() => onEdit?.(record)}
                            >{Icon.edit}</Button>
                        }
                        <Button
                            background
                            red
                            small
                            onClick={() => onDelete?.(record)}
                        >{Icon.delete}</Button>
                    </Space>
                </div>
            )
        }
    ];

    const dataSource = items.map(item => ({key: item.id, ...item}));

    return (
        <div className="table-wrapper">
            <div className="table-box">
                <Table
                    columns={columns}
                    dataSource={dataSource}
                    scroll={{ y: tableHeight, x: 'max-content' }}
                    pagination={false}
                    size="middle"
                    rowClassName={(record) => expandedKeys.includes(record.id) ? 'purchase-order-row-expanded' : ''}
                    expandable={{
                        expandedRowKeys: expandedKeys,
                        onExpandedRowsChange: setExpandedKeys,
                        expandedRowRender: (record) => {
                            const details = detailsData[record.id] || [];
                            const isLoading = detailsLoading[record.id];
                            return <PurchaseOrderDetail
                                record={record}
                                details={details}
                                isLoading={isLoading}
                                appData={appData}
                            />;
                        },
                    }}
                    onRow={(record) => ({
                        onClick: () => handleExpandDetails(record)
                    })}
                />
            </div>
            <Pagination
                current={pagination?.page}
                defaultCurrent={1}
                defaultPageSize={20}
                pageSize={pagination?.limit}
                total={pagination?.total}
                onChange={onPaginationChange}
                showSizeChanger={false}
            />
        </div>
    );
}

export default PurchaseOrderTable;
